module.exports = __webpack_public_path__ + "grootstatic/media/bharat-petroleum.8026e381.svg";